import React, {useRef, useContext} from 'react'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'
import BarcodeLabelTextToolbar from '../BarcodeLabelTextToolbar'
import useStyles from './BarcodeLabelEditableText.styles'

function BarcodeLabelEditableText(props) {
  const {state} = useContext(BarcodeLabelEditorContext)
  const classes = useStyles(props)
  const {item} = props
  const refInput = useRef()
  const handleChange = e => {
    if (item.size.height < e.target.scrollHeight) {
      item.size.height = parseFloat(e.target.scrollHeight)
    }
    item.text = e.target.value

    props.onChange({...item})
  }

  const handleChangeToolbar = (k, v) => {
    if (k === 'font_size') {
      v *= state.zoom
    }
    props.onChange({...item, [k]: v, focused: true})
  }

  const handleBlur = e => {
    e.preventDefault()
    e.target.style.height = '100%'
  }

  const handleFocus = e => {
    e.preventDefault()
    e.target.style.height = `${e.target.scrollHeight - 5}px`
  }

  return (
    <React.Fragment>
      <BarcodeLabelTextToolbar
        values={{...item, font_size: item.font_size / state.zoom}}
        show={item.focused}
        onChange={handleChangeToolbar}
      />
      <textarea
        id={`input_${item.key}`}
        ref={refInput}
        style={{
          fontSize: `${item.font_size}pt`,
          fontFamily: item.font_family,
          textDecoration: item.text_decoration,
          fontStyle: item.font_style,
          fontWeight: item.font_weight,
          color: `#${item.color}`,
          textAlign: item.text_align,
          lineHeight: '1.1',
        }}
        className={classes.text}
        value={item.text}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
    </React.Fragment>
  )
}

export default BarcodeLabelEditableText
